import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { RaceSliderHr } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/RaceSliderHr';
import { RaceSliderGr } from 'src/domains/sportsbook/webview/components/racesSlider/greyhoundRacing/RaceSliderGr';
import { sortGreyhoundsSelections, sortSelections } from 'src/domains/layouts/utils/sortSelections';

export interface RaceSliderItemPropsType {
    race: EventModel;
    market: MarketModel;
}

export const RaceSliderItem = observer('RaceSlider', (props: RaceSliderItemPropsType) => {
    const { race, market } = props;

    if (race.sport === 'horseracing') {
        return (
            <RaceSliderHr
                race={race}
                market={market}
                sortSelections={sortSelections}
            />
        );
    }

    return (
        <RaceSliderGr
            race={race}
            market={market}
            sortSelections={sortGreyhoundsSelections}
        />
    );
});
